import React from 'react';
import { UniverseModuleType } from 'src/domains/common/universes.type';
import { features } from './planetsportbet.features';
import { themeColors } from './planetsportbet.config';
import { PlanetSportLogotype } from './planetsportbet.logotype';
import { PlanetSportBetLogo } from 'src/layouts/LoginPage/logos/PlanetSportBetLogo';
import PlanetSportLoginImage from 'src/layouts/LoginPage/loginBgImages/PlanetSportLoginImage.jpg';
import { PlanetSportBrandIconWrapper, CompliancePopupLogo } from './planetsportbet.style';
import { LoginImageWrapper } from 'src/layouts/LoginPage/LoginImage.style';

export const universeModule: UniverseModuleType = {
    themeColors,
    features,
    title: 'PlanetSportBet Backoffice',
    urls: {
        website: 'https://planetsportbet.com/',
        backoffice: 'https://backoffice.planetsportbet.com/',
    },
    BrandIcon: () => <PlanetSportBrandIconWrapper />,
    Logotype: () => <PlanetSportLogotype />,
    LogotypeLoginPage: () => <PlanetSportBetLogo />,
    compliancePopupLogo: () => <CompliancePopupLogo />,
    loginImageContainer: () => <LoginImageWrapper imgSrc={PlanetSportLoginImage} />,
};
